import React, { useEffect, useState,useRef } from 'react';
import Coupansedit from '../../views/PartnerView/Coupansedit';
import { useServiceContext } from '../Context/ServiceContext';
import { useParams } from 'react-router-dom';
import { SignalWifiStatusbarNullRounded } from '@mui/icons-material';
import CoupansEditData from '../../views/PartnerView/CoupansEditData';
import { useBranchContext } from '../../components/Context/BranchContext';
const CoupansEditComponent=()=>{
     const {id,edit} = useParams();
     const [loading, setLoading] = useState(true);
     const didFetch=useRef(false);
     const {FetchBranches} = useBranchContext();
     const {GetPartnerServices} = useServiceContext();
     const [selectedBranches, setSelectedBranches] = useState([]);
     const [selectedServices, setSelectedservices] = useState([]);
     const [selectedServicesone, setSelectedservicesone] = useState([]);
     const [services, setServices] = React.useState([]);
     const [branches, setBranch] = React.useState([]);
     const {GetCoupansById}=useServiceContext();
    const getData=async() =>{
        
        try{
            //const data1= await FetchBranches();
            //setBranch(data1);
            console.log(branches);
            await GetCoupansById(id);
            setLoading(false);
        }catch(error){
            console.log(error);
        } 
       
    }
    useEffect(()=>{
            if(!didFetch.current){
                getData();
                didFetch.current=true;
            }
    },[id,GetCoupansById]);
    return(
        <div>
            {!loading && edit=="false" && <Coupansedit/>}
            {!loading && edit=="true" && <CoupansEditData/>}
        </div>
        
    );
}
export default CoupansEditComponent;